module.exports = __webpack_public_path__ + "img/icon_wy06.664c45eb.png";